import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { RecaptchaComponent } from "ng-recaptcha";
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { AutoFocusDirective } from "src/app/@shared/components/directives/auto-focus.directive";
import { AuthService, UserInput } from "src/app/services/auth/auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import {
  ModalExpiracaoSenhaComponent,
  ModalExpiracaoSenhaModel,
} from "../modal-expiracao-senha/modal-expiracao-senha.component";
import { take } from "rxjs/operators";
import { ModalBloqueioSenhaComponent } from "../modal-bloqueio-senha/modal-bloqueio-senha.component";
import { DatePipe } from "@angular/common";
import { PasswordMeterComponent } from "src/app/@shared/components";
import * as CryptoJS from 'crypto-js';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [AutoFocusDirective],
})
export class LoginComponent implements OnInit, OnDestroy {
  parent: PasswordMeterComponent = new PasswordMeterComponent();
  login = true;
  sCompany = false;
  fPassword = false;
  newPassword = false;
  isLoading = false;
  elEmail: string;
  elPass: string;
  elUsuario: string;
  newPass: string;
  confirmNewPass: string;
  secondStepCode: string;
  expiredPassNewPass: string;
  confirmExpiredPassNewPass: string;
  recoverUser = null;
  code = null;
  secretCodeVerify = false;
  secretCode = null;
  secretCode2faToken = null;
  hashedToken = null;
  secretCode2fa = false;
  recoverPassword = false;
  secondStepAuth = false;
  public passwordIsValid = false;
  returnUser : any;
  diasExpiracaoSenha : number = 1;
  ultimaTentativaAcesso : string;
  login2fa : number;
  ultimoIp: string = '';
  userIp: string = '';
  hide = true;
  errorMessage: string;
  isBusy = false;
  loginAttempts = 0;
  recaptchaOK = false;
  disableAccess = false;
  enableCaptcha = false;
  maxTentativas;

  usuario = new FormControl("", [Validators.required]);

  user: UserInput = {
    password: "",
  };
  formLogin: FormGroup;
  formRecoverPassword: FormGroup;
  formCodeVerify: FormGroup;
  formCodeVerify2fa: FormGroup;
  formNewPassword: FormGroup;

  selectedData = {};
  clientId = null;
  cliente = {};

  // spinner
  color = "primary";
  mode = "indeterminate";
  value = 10;

  @ViewChild("captchaRef")
  public captchaRef: RecaptchaComponent;

  companies: any[] = [];
  tokenTempoValidadeLogin: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public renderer2: Renderer2,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.renderer2.addClass(document.body.parentElement, "body-no-header");
    this.renderer2.addClass(document.body, "body-no-header");
    this.getUserIP();

    this.formLogin = this.formBuilder.group({
      usuario: ["", Validators.required],
      password: ["", Validators.required],
    });
    this.formRecoverPassword = this.formBuilder.group({
      recoverPasswordUser: ["", Validators.required],
    });
    this.formCodeVerify = this.formBuilder.group({
      secretCodeValidation: ["", Validators.required],
    });
    this.formCodeVerify2fa = this.formBuilder.group({
      secretCodeValidation2fa: ["", Validators.required],
    });
    this.formNewPassword = this.formBuilder.group({
      newPasswordValidation: ["", Validators.required],
      confirmNewPasswordValidation: ["", Validators.required],
    });
  }

  getUserIP() {
    fetch("https://api64.ipify.org?format=json")
      .then(response => response.json())
      .then(data => {
        this.userIp = data.ip; 
      })
      .catch(error => {
      });
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  ngOnDestroy() {
    this.renderer2.removeClass(document.body.parentElement, "body-no-header");
    this.renderer2.removeClass(document.body, "body-no-header");

    document.body.className = "";
    document.documentElement.className = "";
  }

  getErrorMessage() {}

  recaptchaResolved(event) {
    this.recaptchaOK = true;
    this.disableAccess = false;
  }

  defaultForm(): any {
    this.login = true;
    this.sCompany = false;
    this.fPassword = false;
    this.newPassword = false;
    this.secretCodeVerify = false;
    this.recoverPassword = false;
    this.secondStepAuth = false;
    
    // campos
    this.secretCode2fa = null;
    this.newPass = null;
    this.confirmNewPass = null;
    this.secretCode = null;
    this.secondStepCode = null;
    this.recoverUser = null;
  }

  forgetPassword(): any {
    this.login = false;
    this.sCompany = false;
    this.fPassword = true;
    this.newPassword = false;
    this.secretCodeVerify = false;
    this.recoverPassword = false;
    this.secretCode = null;
    this.secondStepAuth = false;
  }

  verifyAuthenticationCode(): any {
    this.login = false;
    this.sCompany = false;
    this.fPassword = false;
    this.newPassword = false;
    this.secretCodeVerify = true;
    this.recoverPassword = false;
    this.secondStepAuth = false;
  }

  verifyCode2fa(): any {
    this.login = false;
    this.sCompany = false;
    this.fPassword = false;
    this.newPassword = false;
    this.secretCodeVerify = false;
    this.secretCode2fa = true;
    this.recoverPassword = false;
    this.secondStepAuth = false;
  }

  recoverPasswordSection(): any {
    this.login = false;
    this.sCompany = false;
    this.fPassword = false;
    this.newPassword = false;
    this.secretCodeVerify = false;
    this.recoverPassword = true;
    this.newPass = null;
    this.secondStepAuth = false;
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

   validarUltimaTentativa(ultimaTentativa: string | Date, tempoValidadeMinutos: number): boolean {
    if (!ultimaTentativa || !tempoValidadeMinutos) {
        return false;
    }
    const tentativaData = new Date(ultimaTentativa);
    if (isNaN(tentativaData.getTime())) {
        return false;
    }
    const agora = new Date();
    const mesmoDia = tentativaData.getFullYear() === agora.getFullYear() &&
                     tentativaData.getMonth() === agora.getMonth() &&
                     tentativaData.getDate() === agora.getDate();
    if (!mesmoDia) {
        return false;
    }
    const diffMinutos = (agora.getTime() - tentativaData.getTime()) / (1000 * 60);
    return diffMinutos <= tempoValidadeMinutos;
}

  onLogin() { 
    localStorage.clear();
    const obj = {
      usuario: this.elUsuario,
      password: this.elPass,
    };
    this.isLoading = true;
    this.authService.authenticate(obj).subscribe(
      (response) => {
        this.returnUser = response;
        this.diasExpiracaoSenha = this.returnUser.qtdExpirarSenha;
        this.ultimaTentativaAcesso = this.returnUser.ultimoAcesso;
        this.ultimoIp = this.returnUser.ultimoIp;
        this.login2fa = this.returnUser.login2fa;
        this.tokenTempoValidadeLogin = this.returnUser.tokenTempoValidadeLogin;
        this.isLoading = false;
        if (!this.returnUser.error) {
          if (this.diasExpiracaoSenha <= 5) { 
            
            const dialogRef = this.dialog.open(ModalExpiracaoSenhaComponent, {
              data: <ModalExpiracaoSenhaModel>{
                titulo:
                  this.diasExpiracaoSenha <= 0
                    ? "Sua senha expirou"
                    : `Atenção: Sua senha está há ${this.diasExpiracaoSenha} dia(s) de expirar.`,
                diasExpiracaoSenha: this.diasExpiracaoSenha,
                ultimoIp: this.ultimoIp,
                login2fa: this.login2fa,
                username: response.username,
                nome: response.nome,
                email: response.email,
                retorno: this.returnUser,
                autenticacao2fa: response.autenticacao2fa,
              },
            });

            
            dialogRef.afterClosed().subscribe(async (option) => {
              if (option === 1) {
                this.authService.setState(this.returnUser);
                this.router.navigate(["/dashboard"]);
                this.resetLoginAttemps();
              }
              if (option === 2) { 
                window.location.reload(); 
              } 
            });
          } else {  
            if (this.login2fa == 1 && !this.validarUltimaTentativa(this.ultimaTentativaAcesso, this.tokenTempoValidadeLogin)){
              this.twoFactorCode();
            }else if (this.login2fa == 2 || this.login2fa == null){
              this.openSnackBar(
                "Seu cadastro 2FA contém inconsistencias. Abra um ticket no Simplifique para regularizar o cadastro.",
                "OK",
                5000,
                "danger-snackbar"
              );
            } else if (this.login2fa == 1 && this.validarUltimaTentativa(this.ultimaTentativaAcesso, this.tokenTempoValidadeLogin)) {
              this.authService.setState(this.returnUser);
              this.router.navigate(["/dashboard"]);
              this.resetLoginAttemps();
           } if (this.login2fa == 0) {  
              this.authService.setState(this.returnUser);
              this.router.navigate(["/dashboard"]);
              this.resetLoginAttemps();
          }  
        }
        } else {
          if (response.bSenhaBloqueada === 0) {
            this.disableAccess = true;
            this.msgBloqueioDeSenha(response.username);
          } else {
            const dataAtual = new Date();
            if (
              response.novaDataTentativaAcesso !== null &&
              response.novaDataTentativaAcesso >
                this.datePipe.transform(dataAtual, "yyyy-MM-ddTHH:mm:ss.SS")
            ) {

              this.loginAttempts = response.qtdUltimaTentativaAcesso;
            }
            this.loginAttempts++;
            const usuario = this.elUsuario ?? "";
            this.maxTentativas = response.maxTentativasInsucesso;
            if (
              this.loginAttempts < response.maxTentativasInsucesso &&
              response.maxTentativasInsucesso < response.qtdBloqueioSenha
            ) {
              this.msgUsuarioSenhaInvalidos(usuario, this.loginAttempts);
              this.disableAccess = false;
            }
            if (
              this.loginAttempts == response.maxTentativasInsucesso &&
              response.maxTentativasInsucesso < response.qtdBloqueioSenha
            ) {
              this.msgEntreTentativas(usuario, this.loginAttempts);
              this.disableAccess = true;
            }
            if (
              this.loginAttempts > response.maxTentativasInsucesso &&
              this.loginAttempts <= response.qtdBloqueioSenha - 2
            ) {
              this.msgUsuarioSenhaInvalidos(usuario, this.loginAttempts);
              this.enableCaptcha = true;
              this.disableAccess = true;
            } else if (this.loginAttempts == response.qtdBloqueioSenha - 1) {
              this.msgUltimaTentativa(usuario, this.loginAttempts);
              this.enableCaptcha = true;
              this.disableAccess = true;
            }
            if (
              this.loginAttempts >= response.qtdBloqueioSenha &&
              response.bSenhaBloqueada !== 0
            ) {
  
              this.authService
                .bloquearPassword(usuario)
                .subscribe(
                  (response) => {
                    if (response) {
                      this.msgBloqueioDeSenha(usuario, this.loginAttempts);
                    } else {
                      this.openSnackBar(
                        "Usuário inexistente!",
                        "OK",
                        5000,
                        "danger-snackbar"
                      );
                    }
                  },
                  (error: HttpErrorResponse) => {
                    console.error(error.message);
                  }
                )
                .add(() => {
                  this.isLoading = false;
                });
              this.disableAccess = true;
            }
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          "Ocorreu um erro com a requisição." + err.message,
          "OK",
          5000,
          "danger-snackbar"
        );
      }
    );
  }

  msgUsuarioSenhaInvalidos(userName, tentativas) {
    const obj = {
      usuario: userName,
      qtdTentativa: tentativas,
      enviarEmail: false,
      mensagem: null,
    };
    this.authService.updateAcessAttemp(obj).subscribe(
      (response) => {
        if (response) {
        }
      },
      (error: HttpErrorResponse) => {
        console.error(error.message);
      }
    );
    this.openSnackBar(
      "Usuário e/ou senha inválidos.",
      "OK",
      5000,
      "danger-snackbar"
    );
  }

  resetLoginAttemps() {
    this.envioTentativas(this.elUsuario, 0);
    this.loginAttempts = 0;
    this.enableCaptcha = false;
    this.disableAccess = false;
  }

  envioTentativas(userName, tentativas) {
    const obj = {
      usuario: userName,
      qtdTentativa: tentativas,
      enviarEmail: false,
      mensagem: null,
    };
    this.authService.updateAcessAttemp(obj).subscribe(
      (response) => {
        if (response) {
        }
      },
      (error: HttpErrorResponse) => {
        console.error(error.message);
      }
    );
  }

  msgEntreTentativas(userName, tentativas) {
    const mensagem = `O usuário ${userName} teve ${tentativas} tentativas de acesso sem sucesso.`;
    this.modalBloqueioSenha(mensagem, async (response) => {
      if (response || !response) {
        const obj = {
          usuario: userName,
          qtdTentativa: tentativas,
          enviarEmail: true,
          mensagem: mensagem,
        };
        this.authService.updateAcessAttemp(obj).subscribe(
          (response) => {
       
            if (response) {
      
            }
          },
          (error: HttpErrorResponse) => {
       
            console.error(error.message);
          }
        );
      }
    });
  }

  msgUltimaTentativa(userName, tentativas) {
    const mensagem = `O usuário ${userName} teve ${tentativas} tentativas de acesso sem sucesso. Caso tenha mais 1 tentativa sem sucesso sua senha será bloqueada`;
    this.modalBloqueioSenha(mensagem, async (response) => {
      if (response || !response) {
        const obj = {
          usuario: userName,
          enviarEmail: true,
          qtdTentativa: tentativas,
          mensagem: mensagem,
        };
        this.authService.updateAcessAttemp(obj).subscribe(
          (response) => {
            if (response) {
            }
          },
          (error: HttpErrorResponse) => {
            console.error(error.message);
          }
        );
      }
    });
  }

  msgBloqueioDeSenha(userName, tentativas?) {
    const mensagem = `O usuário ${userName} teve o número de tentativas de acesso sem sucesso esgotada e com isso teve sua senha bloqueada. Procure o suporte para que o usuário tenha seu acesso restaurado.`
    this.modalBloqueioSenha(
      mensagem,
      async response => {
        if (response || !response) {
          const obj = {
            usuario: userName,
            qtdTentativa: tentativas,
            enviarEmail: true,
            mensagem: mensagem
          }
          this.authService.updateAcessAttemp(obj).subscribe(
            (response) => {
              if (response) {
              }
            },
            (error: HttpErrorResponse) => {
              console.error(error.message);
            }
          );
        };
      });
  }

  modalBloqueioSenha(texto, callback) {
    const dialogRef = this.dialog.open(ModalBloqueioSenhaComponent, {
      width: "540px",
      data: {
        textoOk: "Fechar",
        texto,
      },
    });
    dialogRef.afterClosed().pipe(take(1)).subscribe(callback);
  }

  async forgotPassword() {
    this.isLoading = true;
    if (!this.formRecoverPassword.invalid) {
      await this.authService
        .forgotPassword(this.recoverUser)
        .toPromise()
        .then(
          (response) => {
            this.isLoading = false;
            if (response) {
              this.openSnackBar(
                "E-mail enviado com sucesso, verifique sua caixa de entrada!",
                "OK",
                5000,
                "success-snackbar"
              );
              this.verifyAuthenticationCode();
            } else {
              return this.openSnackBar(
                "Usuário incorreto, não cadastrado, bloqueado ou com e-mail em domínio incorreto. Entre em contato com o suporte para atualização cadastral!",
                "OK",
                5000,
                "danger-snackbar"
              );
            }
          },
          (error: HttpErrorResponse) => {
            this.openSnackBar(error.error, "OK", 5000);
            console.error(error.message);
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = false;
      return;
    }
  }
  async twoFactorCode() {
    this.isLoading = true;
    //if (!this.formCodeVerify2fa.invalid) {
      await this.authService
        .twoFactorCode(this.returnUser.username)
        .toPromise()
        .then(
          (response) => {
            this.isLoading = false;
            if (response) {
              this.openSnackBar(
                "E-mail enviado com sucesso, verifique sua caixa de entrada!",
                "OK",
                5000,
                "success-snackbar"
              );
              this.verifyCode2fa();
            } else {
              return this.openSnackBar(
                "Usuário incorreto, não cadastrado, bloqueado ou com e-mail em domínio incorreto. Entre em contato com o suporte para atualização cadastral!",
                "OK",
                5000,
                "danger-snackbar"
              );
            }
          },
          (error: HttpErrorResponse) => {
            this.openSnackBar(error.error, "OK", 5000);
            console.error(error.message);
            this.isLoading = false;
          }
        );
  }
  

  verifyCode() {
    this.isLoading = true;
    if (!this.formCodeVerify.invalid) {
      this.authService
        .checkAuthenticationCode(this.secretCode, this.recoverUser)
        .subscribe(
          (response) => {
            if (response) {
              this.recoverPasswordSection();
            } else {
              this.openSnackBar(
                "O código digitado é inválido.",
                "OK",
                5000,
                "danger-snackbar"
              );
            }
          },
          (error: HttpErrorResponse) => {
            console.error(error.message);
          }
        )
        .add(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
      return;
    }
  }

  verifyCodeLogin() {
    this.isLoading = true;

    if (!this.formCodeVerify2fa.invalid) {

      const hashedToken = CryptoJS.SHA256(this.secretCode2faToken).toString()
      
      this.authService

        .checkAuthenticationCode2fa(hashedToken, this.returnUser.username)
        .subscribe(
          (response) => {
            if (response && response.teveSucesso == 1) {
            this.authService.setState(this.returnUser);
            this.router.navigate(["/dashboard"]);
            this.resetLoginAttemps();
            } else {
              const codigosRetorno = [2, 3, 4, 5, 7];
              if(codigosRetorno.includes(response.mensagemCodigo))
                {
                this.openSnackBar(
                  response?.mensagem,
                  "OK",
                  5000,
                  "danger-snackbar");
              this.defaultForm()

              } else {
              this.openSnackBar(
                response?.mensagem,
                "OK",
                5000,
                "danger-snackbar"
              );
            }}
          },
          (error: HttpErrorResponse) => {
            console.error(error.message);
          }
        )
        .add(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
      return;
    }
  }

  updatePassword() {
    this.isLoading = true;
    if (!this.formNewPassword.invalid) {
      if (this.newPass !== this.confirmNewPass) {
        this.openSnackBar(
          "As senhas não coincidem.",
          "OK",
          5000,
          "danger-snackbar"
        );
        this.isLoading = false;
      } else if (!this.isStrongPwd(this.newPass)) {
        this.openSnackBar(
          "A senha precisa ter ao menos 8 dígitos, sendo uma letra maiúscula, uma letra minúscula, um número e um caractere especial.",
          "OK",
          5000,
          "danger-snackbar"
        );
        this.isLoading = false;
      } else {
        var obj = {
          usuario: this.recoverUser,
          password: this.newPass,
        };
        this.authService.atualizarSenha(obj).subscribe((response) => {
          if (response) {
            this.isLoading = false;
            this.openSnackBar(
              "Senha atualizada com sucesso!",
              "OK",
              3000,
              "success-snackbar"
            );
            window.location.reload();
          } else {
            this.formNewPassword.reset({
              newPasswordValidation: "",
              confirmNewPasswordValidation: "",
            });
            this.newPass = "";
            this.confirmNewPass = "";
            this.openSnackBar(
              "A nova senha deve ser diferente das senhas anteriores!",
              "OK",
              5000,
              "danger-snackbar"
            );
            this.isLoading = false;
          }
        });
      }
    } else {
      this.isLoading = false;
      return;
    }
  }

  isStrongPwd(password) {
    let uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let lowercase = "abcdefghijklmnopqrstuvwxyz";
    let digits = "0123456789";
    let splChars = "!@#$%&*()";

    let ucaseFlag = this.contains(password, uppercase);
    let lcaseFlag = this.contains(password, lowercase);
    let digitsFlag = this.contains(password, digits);
    let splCharsFlag = this.contains(password, splChars);
    let seqFlag = !/(.)\1/.test(password);

    if (
      password.length >= 8 &&
      ucaseFlag &&
      lcaseFlag &&
      digitsFlag &&
      splCharsFlag &&
      seqFlag
    )
      return true;
    else return false;
  }

  contains(password, allowedChars) {
    for (let i = 0; i < password.length; i++) {
      const char = password.charAt(i);
      if (allowedChars.indexOf(char) >= 0) {
        return true;
      }
    }
    return false;
  }
}
